import { useEffect, useMemo } from "react";
import "./community.css";

export function useEscape(onClose, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose, active]);
}

export function Scrim({ onClose, children, testid, width }) {
  useEscape(onClose);
  return (
    <div className="gw gw-scrim" data-testid={testid} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }} role="dialog" aria-modal="true">
      <div className="gw-modal" style={width ? { width: `min(100%, ${width}px)` } : undefined}>{children}</div>
    </div>
  );
}

export function CloseX({ onClick, testid }) {
  return <button type="button" className="gw-x" onClick={onClick} aria-label="Close" data-testid={testid}>×</button>;
}

const COLORS = ["#E8C46B", "#FFE7A8", "#5BD48F", "#F2EEE3", "#D9A94A"];

export function Confetti() {
  const bits = useMemo(() => Array.from({ length: 48 }, (_, i) => ({
    left: `${Math.random() * 100}%`, background: COLORS[i % 5], "--t": `${1.6 + Math.random() * 1.4}s`, "--dl": `${Math.random() * 0.4}s`,
    "--x": `${(Math.random() - 0.5) * 200}px`, "--r": `${Math.random() * 720}deg`,
  })), []);
  return <div className="gw-confetti" aria-hidden="true">{bits.map((s, i) => <i key={i} style={s} />)}</div>;
}
